<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms["BANK_ACCOUNTS"]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="fullPage">
            </loading>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </b-col>
                    <b-col cols="4">
                       <base-button type="success" @click="addNew" class="float-right">
                          <i class="fa fa-plus"></i>
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="11" >
                    <base-input :label="language_terms['FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch()">
                    </base-input>
                  </b-col>
                  
                  <b-col cols="1" class="mt-4">
                    <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                  </b-col>
                </b-row>
              </card>
              <!-- Search Results -->
              <PaginatedTables :myColumns="tableColumns" :tableData="tableItems" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="tableItems.length > 0"/>

            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

export default {
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
      }),
    },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
  },
  async mounted()
  {
    this.loading = true

    this.updateTableLang()

    this.loading = false
      
  },

  data(){
    return{
      fullPage:true,
      loading:false,
      filter:{
        keyword: null,
        limit:""
      },
      tableItems:[],
      tableColumns: [
            {             
              prop: 'code',
              label: 'Bank Code',
              minWidth: 135,
              sortable: true,
              key:'CODE'

            },
            {
              prop: 'bank_name',
              label: 'Bank Name',
              minWidth: 180,
              sortable: true,
              key:'BANK_NAME'

            },
            {
              prop: 'currency_code',
              label: 'Currency',
              minWidth: 120,
              sortable: true,
              key:'CURRENCY_CODE'

            },
            {
              prop: 'account_code',
              label: 'Account Code',
              minWidth: 130,
              sortable: true,
              key:'ACCOUNT_CODE'
            },  
            {
              prop: 'require_recon',
              label: 'Require Recon',
              minWidth: 130,
              sortable: true,
              key:'REQUIRE_RECON'
            },     
            {
              prop: 'country_code',
              label: 'Country',
              minWidth: 130,
              sortable: true,
              key:'COUNTRY_CODE'
            },    
      ],
      status_options:[
        {
          label:"All",
          value:"ALL"
        },
        {
          label:"Open",
          value:"OPEN"
        },
        {
          label:"Posted",
          value:"POSTED"
        },
        {
          label:"Cancelled",
          value:"CANCELLED"
        },
      ],
      sales_types:[
        {
          label:"Quotation",
          value:"SQ"
        },
        {
          label:"Order",
          value:"SO"
        },
        {
          label:"Invoice",
          value:"SI"
        }
      ]

    }
  },

  methods:{
    updateTableLang(){
      // for(let i=0; i < this.do_tableColumns.length;i++)
      // {
      //   let key = this.do_tableColumns[i].key
      //   this.do_tableColumns[i].label = this.language_terms[key]
      // }

    },
    async clickOnSearch()
    {
      this.loading = true

      this.filter.limit = ''
      let payload = this.filter
          
      await axios
      .post(apiRoutes["BANKACCOUNTS_QUICK_SEARCH"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          // alert('Success' + response.data.data[0].code)
          this.tableItems = response.data.data
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      
      this.loading = false
    },
    clickOnReset(){
      this.filter = {
          keyword:"",
          //date_from:null,
          //date_to:null,
          //type:'SQ',
          //status:'ALL'
      }
    },
    async addNew()
    {
      let url = '/settings/bank-account/_new'
      this.$router.push(url)
    }
  }
}
</script>
